import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-moss bg-deep" data-id="element-235" data-mp="3rjw0bkxgv4kv">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 pb-28 pt-12 md:grid-cols-[1fr_1.4fr]" data-id="element-236" data-mp="1bealxh7tc0jo">
        <div data-id="element-237" data-mp="1fg5oep1hcjz1">
          <p className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-238" data-mp="1fhqg86wetot7">
            HYROX <span className="text-gold" data-id="element-239" data-mp="1kg0eiqdfl5j1">Mega Pack™</span>
          </p>
          <p className="text-base text-white/60" data-id="element-240" data-mp="nphofgbjlkmy">6 Months of Ready-to-Use Training Plans</p>
        </div>
        <div className="space-y-3 text-sm leading-relaxed text-white/60" data-id="element-241" data-mp="rqtefmybw7vo">
          <p data-id="element-242" data-mp="rp03hvgon1hv">
            <span className="font-semibold text-white" data-id="element-243" data-mp="wq62gb0xrkzu">Digital product.</span> Delivered as downloadable PDF files to
            view on your device or print. No physical items are shipped.
          </p>
          <p data-id="element-244" data-mp="41ida4d2gbh0">
            <span className="font-semibold text-white" data-id="element-245" data-mp="421utjyt0xui">10-day guarantee.</span> Contact the store within 10 days of
            your purchase to request a refund.
          </p>
          <p data-id="element-246" data-mp="an3vh3doebst">
            <span className="font-semibold text-white" data-id="element-247" data-mp="amvh171wmyfi">Independent resource.</span> Not affiliated with, sponsored by,
            or endorsed by HYROX. It does not provide coaching certification.
          </p>
        </div>
      </div>
    </footer>;
}